import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Table } from '@syneto/compass-react';

// Calendar dates stored at UTC midnight (see client/helpers/addonPeriod.js): format them in UTC
// so the day shown does not shift with the browser's time zone, and in the same format as the rows.
const renderDate = (value) => {
	const date = value ? moment.utc(value) : null;

	return date && date.isValid() ? date.format('DD/MM/YYYY') : 'N/A';
};

// The duration of a "follows maintenance" row is a placeholder the server stores; it is never shown.
const renderDuration = (value, row) => {
	if (row.followsMaintenance) {
		return 'Follows maintenance';
	}

	return `${value} ${row.durationType}`;
};

const renderTier = (value, row) => {
	const tier = row.addon.addonTiers.find((tier) => { return tier.id === value; });
	if (!tier) { return 'N/A'; }
	
	const unitInfo = tier.unitOfMeasurement ? ` (${tier.unitOfMeasurement.symbol})` : '';
	return `${tier.name}${unitInfo}`;
};

const ExpiredProductAddons = ({ addons }) => {
	return (
		<Table data={addons} keyField='id'>
			<Table.Col field="addon.name" align="left">
				License Name
			</Table.Col>
			<Table.Col field="addonType" align="left">
				Type
			</Table.Col>
			<Table.Col field="startDate" align="left" renderCell={renderDate}>
				Start date
			</Table.Col>
			<Table.Col field="endDate" align="left" renderCell={renderDate}>
				Expiration date
			</Table.Col>
			<Table.Col field="duration" align="left" renderCell={renderDuration}>
				Duration
			</Table.Col>
			<Table.Col field="tierId" align="left" renderCell={renderTier}>
				Tier
			</Table.Col>
		</Table>
	);
};

export default ExpiredProductAddons;
ExpiredProductAddons.propTypes = {
	addons: PropTypes.array.isRequired,
};
